export default __webpack_public_path__ + "static/media/gallery.1b9fa73c.gif";